import { computed } from 'vue';
import { formatDateTime } from './dateTools';

export interface IBaseFormFields {
  date: string;
  ipAddress: string;
  browser: string;
  [key: string]: string | number | undefined;
}

const isTermsFieldKey = (params: IBaseFormFields, key: string): boolean => key in params;

export const processedFormHTML = (templateString: string, params: IBaseFormFields) => {
  return templateString && params
    ? templateString.replace(/\{\{(.*?)\}\}/g, (_: string, key: string) => {
        const trimmedKey = key.trim();
        return isTermsFieldKey(params, trimmedKey) ? String(params[trimmedKey] ?? '') : '';
      })
    : '';
};

export const currentDate = computed(() => {
  const currentDate = new Date().toLocaleString();
  return formatDateTime(currentDate);
});
export const browser = computed(() => navigator.userAgent);
export const userIP = computed(async () => await getIP());
const getIP = async (): Promise<string | undefined> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Error fetching IP:', error);
  }
};
